import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
  MDS_START_POLL_DELAY,
  MDS_START_POLL_INTERVAL,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface MysqlStartProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const MysqlStart = (
  { location, databaseId, onExecute }: MysqlStartProps,
): JSX.Element => {
  const { invokeCall: invokeStart } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).mdsDatabaseApi.startMdsDbSystem },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resourceGroupName = decodeURIComponent(resourceGroup || "");
    const dbSystemName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.startMysql(),
          message: Messages.notifications.inProgress.messages.startMysql(dbSystemName),
        },
        success: {
          title: Messages.notifications.success.titles.startMysql(),
          message: Messages.notifications.success.messages.startMysql(dbSystemName),
        },
        failure: {
          title: Messages.notifications.failure.titles.start(),
          message: Messages.notifications.failure.messages.startMysql(dbSystemName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.MDS_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName,
            dbSystemName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.MDS_STARTED_CHECK,
          delay: MDS_START_POLL_DELAY,
          interval: MDS_START_POLL_INTERVAL,
        },
      },
    };
    invokeStart({
      subscriptionId,
      resourceGroupName,
      dbSystemName,
    }, invokeOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newMysqlStart = (
  props: MysqlStartProps,
): JSX.Element => (<MysqlStart {...props} />);
